 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"views/images/Lightbox":"views/images/Lightbox","views/images/ModalImages":"views/images/ModalImages","views/images/Slideshow":"views/images/Slideshow","views/images/SlideshowGallery":"views/images/SlideshowGallery","views/menus/Accordion":"views/menus/Accordion","views/menus/BottomBorderNavLinks":"views/menus/BottomBorderNavLinks","views/menus/BottomNavigation":"views/menus/BottomNavigation","views/menus/Breadcrumbs":"views/menus/Breadcrumbs","views/menus/ButtonGroup":"views/menus/ButtonGroup","views/menus/ClickableDropdown":"views/menus/ClickableDropdown","views/menus/DropdownNavbar":"views/menus/DropdownNavbar","views/menus/FixedMenu":"views/menus/FixedMenu","views/menus/FullscreenNavigation":"views/menus/FullscreenNavigation","views/menus/HorizontalScrollMenu":"views/menus/HorizontalScrollMenu","views/menus/HoverableDropdown":"views/menus/HoverableDropdown","views/menus/HoverableSidenav":"views/menus/HoverableSidenav","views/menus/IconBar":"views/menus/IconBar","views/menus/MegaMenu":"views/menus/MegaMenu","views/menus/MenuIcon":"views/menus/MenuIcon","views/menus/OffCanvasMenu":"views/menus/OffCanvasMenu","views/menus/Pagination":"views/menus/Pagination","views/menus/ResponsiveBottomNavigation":"views/menus/ResponsiveBottomNavigation","views/menus/ResponsiveTopnav":"views/menus/ResponsiveTopnav","views/menus/SideNavigation":"views/menus/SideNavigation","views/menus/SlideDownBarOnScroll":"views/menus/SlideDownBarOnScroll","views/menus/StickyNavbar":"views/menus/StickyNavbar","views/menus/TabHeaders":"views/menus/TabHeaders","views/menus/Tabs":"views/menus/Tabs","views/menus/TopNavigation":"views/menus/TopNavigation","views/menus/VerticalButtonGroup":"views/menus/VerticalButtonGroup","views/menus/VerticalMenu":"views/menus/VerticalMenu","views/menus/VerticalTabs":"views/menus/VerticalTabs","views/more/ModalBoxes":"views/more/ModalBoxes"}[chunkId]||chunkId) + "." + {"views/images/Lightbox":"c4e02545","views/images/ModalImages":"e1e9e9c2","views/images/Slideshow":"072cdbdb","views/images/SlideshowGallery":"f2622532","views/menus/Accordion":"20a07394","views/menus/BottomBorderNavLinks":"ae7a5272","views/menus/BottomNavigation":"0d8f5ef3","views/menus/Breadcrumbs":"295df4e3","views/menus/ButtonGroup":"da6a9489","views/menus/ClickableDropdown":"876a1025","views/menus/DropdownNavbar":"8b122592","views/menus/FixedMenu":"973afee0","views/menus/FullscreenNavigation":"5f04d9a4","views/menus/HorizontalScrollMenu":"d416b889","views/menus/HoverableDropdown":"7617db9a","views/menus/HoverableSidenav":"1e55f4b1","views/menus/IconBar":"a428d3c5","views/menus/MegaMenu":"2b82522d","views/menus/MenuIcon":"349d256b","views/menus/OffCanvasMenu":"4a0cf03e","views/menus/Pagination":"a7aa2568","views/menus/ResponsiveBottomNavigation":"4277ccb5","views/menus/ResponsiveTopnav":"64d4e05a","views/menus/SideNavigation":"c163b50e","views/menus/SlideDownBarOnScroll":"2c740617","views/menus/StickyNavbar":"b7782a80","views/menus/TabHeaders":"a8658b92","views/menus/Tabs":"45fcbca8","views/menus/TopNavigation":"0ae29ba7","views/menus/VerticalButtonGroup":"79586363","views/menus/VerticalMenu":"ae2e11af","views/menus/VerticalTabs":"5607986c","views/more/ModalBoxes":"46c03a08"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"views/images/Lightbox":1,"views/images/ModalImages":1,"views/images/Slideshow":1,"views/images/SlideshowGallery":1,"views/menus/Accordion":1,"views/menus/BottomBorderNavLinks":1,"views/menus/BottomNavigation":1,"views/menus/Breadcrumbs":1,"views/menus/ButtonGroup":1,"views/menus/ClickableDropdown":1,"views/menus/DropdownNavbar":1,"views/menus/FixedMenu":1,"views/menus/FullscreenNavigation":1,"views/menus/HorizontalScrollMenu":1,"views/menus/HoverableDropdown":1,"views/menus/HoverableSidenav":1,"views/menus/IconBar":1,"views/menus/MegaMenu":1,"views/menus/MenuIcon":1,"views/menus/OffCanvasMenu":1,"views/menus/Pagination":1,"views/menus/ResponsiveBottomNavigation":1,"views/menus/ResponsiveTopnav":1,"views/menus/SideNavigation":1,"views/menus/SlideDownBarOnScroll":1,"views/menus/StickyNavbar":1,"views/menus/TabHeaders":1,"views/menus/Tabs":1,"views/menus/TopNavigation":1,"views/menus/VerticalButtonGroup":1,"views/menus/VerticalMenu":1,"views/menus/VerticalTabs":1,"views/more/ModalBoxes":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"views/images/Lightbox":"views/images/Lightbox","views/images/ModalImages":"views/images/ModalImages","views/images/Slideshow":"views/images/Slideshow","views/images/SlideshowGallery":"views/images/SlideshowGallery","views/menus/Accordion":"views/menus/Accordion","views/menus/BottomBorderNavLinks":"views/menus/BottomBorderNavLinks","views/menus/BottomNavigation":"views/menus/BottomNavigation","views/menus/Breadcrumbs":"views/menus/Breadcrumbs","views/menus/ButtonGroup":"views/menus/ButtonGroup","views/menus/ClickableDropdown":"views/menus/ClickableDropdown","views/menus/DropdownNavbar":"views/menus/DropdownNavbar","views/menus/FixedMenu":"views/menus/FixedMenu","views/menus/FullscreenNavigation":"views/menus/FullscreenNavigation","views/menus/HorizontalScrollMenu":"views/menus/HorizontalScrollMenu","views/menus/HoverableDropdown":"views/menus/HoverableDropdown","views/menus/HoverableSidenav":"views/menus/HoverableSidenav","views/menus/IconBar":"views/menus/IconBar","views/menus/MegaMenu":"views/menus/MegaMenu","views/menus/MenuIcon":"views/menus/MenuIcon","views/menus/OffCanvasMenu":"views/menus/OffCanvasMenu","views/menus/Pagination":"views/menus/Pagination","views/menus/ResponsiveBottomNavigation":"views/menus/ResponsiveBottomNavigation","views/menus/ResponsiveTopnav":"views/menus/ResponsiveTopnav","views/menus/SideNavigation":"views/menus/SideNavigation","views/menus/SlideDownBarOnScroll":"views/menus/SlideDownBarOnScroll","views/menus/StickyNavbar":"views/menus/StickyNavbar","views/menus/TabHeaders":"views/menus/TabHeaders","views/menus/Tabs":"views/menus/Tabs","views/menus/TopNavigation":"views/menus/TopNavigation","views/menus/VerticalButtonGroup":"views/menus/VerticalButtonGroup","views/menus/VerticalMenu":"views/menus/VerticalMenu","views/menus/VerticalTabs":"views/menus/VerticalTabs","views/more/ModalBoxes":"views/more/ModalBoxes"}[chunkId]||chunkId) + "." + {"views/images/Lightbox":"f07cd728","views/images/ModalImages":"8174d9ff","views/images/Slideshow":"dd8d5537","views/images/SlideshowGallery":"371c1846","views/menus/Accordion":"a8645e20","views/menus/BottomBorderNavLinks":"64ba8f1e","views/menus/BottomNavigation":"11fa72c8","views/menus/Breadcrumbs":"4817a3ce","views/menus/ButtonGroup":"48dcf9b2","views/menus/ClickableDropdown":"12e0c1bb","views/menus/DropdownNavbar":"22b45268","views/menus/FixedMenu":"389636c6","views/menus/FullscreenNavigation":"25c32fd3","views/menus/HorizontalScrollMenu":"07690b12","views/menus/HoverableDropdown":"c471495b","views/menus/HoverableSidenav":"29bc0dc9","views/menus/IconBar":"c0248839","views/menus/MegaMenu":"230fd8e0","views/menus/MenuIcon":"97005c14","views/menus/OffCanvasMenu":"7eb800a5","views/menus/Pagination":"4b94246a","views/menus/ResponsiveBottomNavigation":"1e509769","views/menus/ResponsiveTopnav":"9989eb73","views/menus/SideNavigation":"b2b64a20","views/menus/SlideDownBarOnScroll":"2ae396ee","views/menus/StickyNavbar":"d88dd8cf","views/menus/TabHeaders":"05656bb6","views/menus/Tabs":"c6bce2e3","views/menus/TopNavigation":"9989eb73","views/menus/VerticalButtonGroup":"48dcf9b2","views/menus/VerticalMenu":"5aea1c9a","views/menus/VerticalTabs":"c6bce2e3","views/more/ModalBoxes":"b2fe2dbb"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/w3-how-to-with-vue/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
